/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserEntity } from './UserEntity';
import {
    UserEntityFromJSON,
    UserEntityFromJSONTyped,
    UserEntityToJSON,
    UserEntityToJSONTyped,
} from './UserEntity';

/**
 * 
 * @export
 * @interface WorkflowModelEntity
 */
export interface WorkflowModelEntity {
    /**
     * 
     * @type {UserEntity}
     * @memberof WorkflowModelEntity
     */
    createdBy: UserEntity;
    /**
     * 
     * @type {UserEntity}
     * @memberof WorkflowModelEntity
     */
    updatedBy: UserEntity;
    /**
     * ワークフロー定義
     * @type {object}
     * @memberof WorkflowModelEntity
     */
    definition: object;
    /**
     * データスキーマ
     * @type {object}
     * @memberof WorkflowModelEntity
     */
    dataSchema: object;
    /**
     * データアクセスポリシー
     * @type {object}
     * @memberof WorkflowModelEntity
     */
    policy: object;
    /**
     * 履歴の種別
     * [create, update, publish]
     * @type {string}
     * @memberof WorkflowModelEntity
     */
    historyType: WorkflowModelEntityHistoryTypeEnum;
    /**
     * ワークフローモデルID
     * @type {string}
     * @memberof WorkflowModelEntity
     */
    id: string;
    /**
     * ワークフローモデル履歴ID
     * @type {string}
     * @memberof WorkflowModelEntity
     */
    historyId: string;
    /**
     * 現在公開されているかモデルであるかを示します
     * @type {boolean}
     * @memberof WorkflowModelEntity
     */
    isPublished: boolean;
    /**
     * 作成日時
     * @type {Date}
     * @memberof WorkflowModelEntity
     */
    createdAt: Date;
    /**
     * 更新日時
     * @type {Date}
     * @memberof WorkflowModelEntity
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof WorkflowModelEntity
     */
    name: string;
    /**
     * 説明
     * @type {string}
     * @memberof WorkflowModelEntity
     */
    description: string;
    /**
     * バージョン
     * @type {number}
     * @memberof WorkflowModelEntity
     */
    version: number;
}


/**
 * @export
 */
export const WorkflowModelEntityHistoryTypeEnum = {
    Create: 'create',
    Update: 'update',
    Publish: 'publish',
    Deactivate: 'deactivate'
} as const;
export type WorkflowModelEntityHistoryTypeEnum = typeof WorkflowModelEntityHistoryTypeEnum[keyof typeof WorkflowModelEntityHistoryTypeEnum];


/**
 * Check if a given object implements the WorkflowModelEntity interface.
 */
export function instanceOfWorkflowModelEntity(value: object): value is WorkflowModelEntity {
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('updatedBy' in value) || value['updatedBy'] === undefined) return false;
    if (!('definition' in value) || value['definition'] === undefined) return false;
    if (!('dataSchema' in value) || value['dataSchema'] === undefined) return false;
    if (!('policy' in value) || value['policy'] === undefined) return false;
    if (!('historyType' in value) || value['historyType'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('historyId' in value) || value['historyId'] === undefined) return false;
    if (!('isPublished' in value) || value['isPublished'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    return true;
}

export function WorkflowModelEntityFromJSON(json: any): WorkflowModelEntity {
    return WorkflowModelEntityFromJSONTyped(json, false);
}

export function WorkflowModelEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowModelEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'createdBy': UserEntityFromJSON(json['createdBy']),
        'updatedBy': UserEntityFromJSON(json['updatedBy']),
        'definition': json['definition'],
        'dataSchema': json['dataSchema'],
        'policy': json['policy'],
        'historyType': json['historyType'],
        'id': json['id'],
        'historyId': json['historyId'],
        'isPublished': json['isPublished'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'name': json['name'],
        'description': json['description'],
        'version': json['version'],
    };
}

export function WorkflowModelEntityToJSON(json: any): WorkflowModelEntity {
    return WorkflowModelEntityToJSONTyped(json, false);
}

export function WorkflowModelEntityToJSONTyped(value?: WorkflowModelEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdBy': UserEntityToJSON(value['createdBy']),
        'updatedBy': UserEntityToJSON(value['updatedBy']),
        'definition': value['definition'],
        'dataSchema': value['dataSchema'],
        'policy': value['policy'],
        'historyType': value['historyType'],
        'id': value['id'],
        'historyId': value['historyId'],
        'isPublished': value['isPublished'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'name': value['name'],
        'description': value['description'],
        'version': value['version'],
    };
}

